import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';
import {
  PROFILE_SETTINGS_PERMISSIONS,
} from '@modules/profile-settings/constants';

import type {
  ITFASchema,
} from '../types';
import {
  ADMIN_PROFILE_SETTINGS_TFA_CLEAR_URL,
  AFFILIATE_PROFILE_SETTINGS_TFA_CLEAR_URL,
  PROFILE_SETTINGS_TFA_CLEAR_MUTATION_KEY,
} from '../constants';

export default function useProfileSettingsTFAClearMutation(): IContextMutationResult<
  void,
  Error,
  ITFASchema
> {
  const { fetchPost } = useRestClient();
  const { isAdminNamespace } = useCurrentNamespace();

  return useContextMutation<void, Error, ITFASchema>({
    mutationKey: [PROFILE_SETTINGS_TFA_CLEAR_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      isAdminNamespace.value ? ADMIN_PROFILE_SETTINGS_TFA_CLEAR_URL : AFFILIATE_PROFILE_SETTINGS_TFA_CLEAR_URL,
      isAdminNamespace.value ? { admin: payload } : { affiliate: payload },
      {
        permission: PROFILE_SETTINGS_PERMISSIONS.TWO_FACTOR_AUTH,
      },
    ),
  });
}
